import logo from "../../assets/fitoja-logo.jpg";
import maleProfilePic from "../../assets/profile_pic_male.jpeg";
import femaleProfilePic from "../../assets/profile_pic_female.png";
import closeIcon from "../../assets/close_icon.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios for API calls
import "./e_commerce_portal.scss"; // Create and import a CSS file for styling

// Define TypeScript interface for user details
interface UserDetails {
  name: string;
  email: string;
  phoneNumber: string;
  role: string;
  gender: string;
}

const ECommercePortal: React.FC = () => {
  const [role, setRole] = useState<string>("");
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true); // Add loading state
  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  const fetchUserDetails = async () => {
    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");

      if (!email || !token) {
        navigate("/login");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `https://api.fitoja.in/api/get-employee-details/${email}`,
        config
      );

      setUserDetails(response.data);
      setRole(response.data.role);
    } catch (error) {
      handleLogout();
    } finally {
      setLoading(false); // Stop the loading indicator once API responds
    }
  };

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear token on logout
    localStorage.removeItem("email"); // Clear email on logout
    navigate("/login"); // Redirect to login
  };

  // useEffect hook to fetch user details on component mount
  useEffect(() => {
    if (isInitialRender.current) {
      fetchUserDetails();
      isInitialRender.current = false; // Prevent further calls
    }
  }, []);

  return (
    <div className="e-commerce-portal-container">
      {/* Loading indicator */}
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
          {/* Header Section */}
          <header className="e-commerce-portal-header">
            <div className="logo" onClick={() => navigate("/dashboard")}>
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {/* Overlay for showing user details */}
          {showOverlay && userDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {userDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {userDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {userDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {userDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {userDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h1>E-Commerce Portal</h1>
          {/* Dashboard Cards Section */}
          <div className="cards-container">
            <div className="cards-grid">
              <div
                className="card"
                onClick={() => navigate("/e-commerce-portal/products")}
              >
                <h3>All Products</h3>
                <p>
                  Upload new products, Manage all products for Health Store.
                </p>
              </div>
              <div className="card" onClick={() => navigate("/e-commerce-portal/track-orders")}>
                <h3>Track Orders</h3>
                <p>
                  Track all orders, Change the status
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ECommercePortal;
